export const getV3Token = () => {
    return localStorage.getItem('_findme_v3_token')
}